import React from "react";
import { activityOptions, intensityOptions } from "../helpers/ddOptions";
import { strings } from "../loc/langs";

class AddActivity extends React.Component {
  createActivity = event => {
    // Prevent pg refresh.
    event.preventDefault();

    const activity = {
      id: `A${Date.now()}`,
      icon:
        activityOptions[Math.floor(Math.random() * activityOptions.length)]
          .value,
      name: "",
      duration: 0,
      intensity: intensityOptions[0].value
    };

    // The addActivity method lives in the StopwatchContainer component (where the state is).
    this.props.addActivity(this.props.stopwatchindex, activity);
  };

  render() {
    return (
      <div className="add-activity-container">
        <div className="add-activities-btn-container">
          <button type="button" onClick={this.createActivity}>
            <span className="icon">
              <i className="fas fa-plus"></i>
            </span>
            <span className="btn-txt">{strings["AddMoreActivities"]}</span>
          </button>
        </div>
      </div>
    );
  }
}

export default AddActivity;
